import { gql, useQuery } from '@apollo/client';

const isClosedQuery = gql`
    query isClosedQuery($locationId: ID!, $date: DateString!) {
        location(locationId: $locationId) {
            isClosed(date: $date)
        }
    }
`;

type IsClosedQuery = {
    location: {
        isClosed: boolean;
    };
};

export default function useIsClosed(
    locationId: string,
    date: string,
): { isClosed: boolean; loading: boolean } {
    const { data, loading } = useQuery<IsClosedQuery>(isClosedQuery, {
        variables: { locationId, date },
    });

    return {
        isClosed: data?.location.isClosed ?? false,
        loading,
    };
}
